import {Divider} from '@logistics-frontend/blocks/lpc/divider'
import {SupportedRequirement} from '@yandex-taxi/js-integration-api'
import React from 'react'

import {BooleanRequirement, CargoLoadersRequirement, CargoTypeRequirement, SelectRequirement} from './requirement'
import {Props as RequirementProps} from './requirement/types'

type Props = {
  requirements: SupportedRequirement[]
  tariff: string
}

type RequirementMap<TField extends string> = Record<TField, React.ComponentType<RequirementProps> | null>

const typeMap: RequirementMap<SupportedRequirement['type']> = {
  boolean: BooleanRequirement,
  select: SelectRequirement,
  number: null,
  string: null,
}
const nameMap: RequirementMap<SupportedRequirement['name']> = {
  cargo_type: CargoTypeRequirement,
  cargo_type_int: CargoTypeRequirement,
  cargo_loaders: CargoLoadersRequirement,
}

const Requirements: React.FC<Props> = ({requirements, tariff}) => (
  <>
    {requirements.map((requirement, index) => {
      const Component = nameMap[requirement.name] || typeMap[requirement.type]

      return Component ? (
        <React.Fragment key={index}>
          <Component requirement={requirement} tariff={tariff} />
          <Divider />
        </React.Fragment>
      ) : null
    })}
  </>
)

export default Requirements
